import template from './tansa.template.html'
import Controller from './tansa.controller'

export default {
  restrict: 'E',
  template,
  bindings: {
    index: '=',
  },
  controller: Controller,
  controllerAs: 'vm',
}
